import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16"
      style={{ background: "linear-gradient(180deg,#14090a 0%,#0d0605 100%)", color: "#f4ead8" }}
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img
            src="/images/logo.webp"
            alt="Pizzeria Salviano"
            className="h-24 lg:h-28 w-auto"
            loading="lazy"
          />
          <p className="mt-6 text-lg lg:text-xl leading-relaxed text-[#e6d9be]/90 max-w-md">
            Pizzeria Salviano — la tradizione livornese in ogni fetta. Pizza da asporto,
            consegna a domicilio e specialità della cucina locale.
          </p>
        </div>

        <div>
          <h3 className="font-display uppercase tracking-[0.18em] text-[#f5c518] text-lg lg:text-xl mb-5">
            Contatti
          </h3>
          <ul className="space-y-4 text-lg lg:text-xl">
            <li className="flex items-start gap-3">
              <MapPin size={22} className="mt-1 text-[#f5c518] shrink-0" />
              <span>Via Costanza 12/14, Livorno</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={22} className="text-[#f5c518]" />
              <a href="tel:+390586326286" className="hover:text-[#f5c518] transition-colors" data-testid="footer-phone">
                0586 326286
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle size={22} className="text-[#f5c518]" />
              <a
                href="https://wa.me/393703640199"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f5c518] transition-colors"
                data-testid="footer-whatsapp"
              >
                370 3640199 (WhatsApp)
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display uppercase tracking-[0.18em] text-[#f5c518] text-lg lg:text-xl mb-5">
            Orari
          </h3>
          <ul className="space-y-2 text-lg lg:text-xl">
            <li className="flex items-center gap-2">
              <Clock size={18} className="text-[#f5c518]" /> Lunedì —{" "}
              <span className="text-[#e6d9be]/70">Chiuso</span>
            </li>
            <li className="pl-7">Martedì — 18:00 · 21:30</li>
            <li className="pl-7">Mercoledì — 18:00 · 21:30</li>
            <li className="pl-7">Giovedì — 18:00 · 21:30</li>
            <li className="pl-7">Venerdì — 18:00 · 21:30</li>
            <li className="pl-7">Sabato — 18:00 · 21:30</li>
            <li className="pl-7">Domenica — 18:00 · 21:30</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#f5c518]/15">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-base text-[#e6d9be]/80">
          <p>© {year} Pizzeria Salviano — Via Costanza 12/14, Livorno. Tutti i diritti riservati.</p>
          <div className="flex items-center gap-6">
            <Link to="/cookie" className="hover:text-[#f5c518] transition-colors" data-testid="footer-cookie-link">
              Cookie Policy
            </Link>
            <Link to="/privacy" className="hover:text-[#f5c518] transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
